/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  position: relative;

  label {
    font-size: 12px;
    line-height: 14px;
    color: rgba(0, 0, 0, 0.56);
    display: block;
    margin-bottom: 8px;
  }

  input {
    height: 40px;
    width: ${({ width }) => `${width}px` || '324px'};
    height: ${({ height }) => `${height}px` || '40px'};
    margin-bottom: 21px;
    border: 0.5px solid rgba(0, 0, 0, 0.56);
    border-radius: 3px;
    padding: 10px;
    box-sizing: border-box;
    padding-right: ${(props) => (props.rightAdorn ? '40px' : '10px')};
  }

  textarea {
    height: 86px;
    min-width: 324px;
    border: 0.5px solid rgba(0, 0, 0, 0.56);
    border-radius: 3px;
    margin-bottom: 30px;
    padding: 10px;
    box-sizing: border-box;
    resize: none;
  }

  .error {
    position: absolute;
    bottom: 5px;
    color: red;
    font-size: 10px;
  }
`;

/**
 * Estilização do componente PlaceholderInput
 */
export const PlaceholdedInput = styled.div`
  position: relative;

  label {
    position: absolute;
    top: 10px;
    left: 10px;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
  }

  input {
    padding-left: ${(props) => `${props.labelWidth + 12}px`};
    padding-right: ${(props) => (props.rightAdorn ? '40px' : '10px')};
  }
`;

/**
 * Estilização do componente RightAdorn
 */
export const RightAdorn = styled.div`
  position: absolute;
  top: 33px;
  left: 292px;
`;
